import React from 'react';
import PropTypes from 'prop-types';
import uniqueId from 'lodash/uniqueId';
import {
	ApCheckbox,
	ApIcon,
	ApInput,
	ApSimpleDropdown,
} from '@alixpartners/ui-components';

import LoadingIndicator from 'components/LoadingIndicator';
import { Section } from '../../Settings/Section';
import { chartOrange } from 'styles/colors';
import {
	SectionWrapper,
	IntroText,
	PeriodRange,
	PeriodWrapper,
	MonthPickerWrapper,
	SmallInput,
	MonthPickerNameBlock,
	ValueWrapper,
	SectionFormLabel,
	SectionForm,
	SelectWrapper,
	MonthPickerRadio,
	ActionWrapper,
	LinkButton,
	slimRadioStyles,
	CurrencyInputWrapper,
	CurrencyRadio,
	MultiSelectWrapper,
	TooltipContent,
} from './styles';
import { TextInput } from '../../Settings/TextInput';
import RadioGroup, { Radio } from 'components/RadioGroup';
import { getISOString, validateTailSpend } from '../../Settings/utils';
import { Select } from '../../Settings/Select';
import isEmpty from 'lodash/isEmpty';
import debounce from 'lodash/debounce';
import {
	getColumnWithData,
	getPortcoTraces,
	getSettingsOptions,
	getSpendCubeSettings,
} from '../../utils/apiRequests';
import MonthPicker from './MonthPicker';

import { UNITS } from '../../Settings';
import { UPLOAD_STATUS } from 'Data/constants';
import { MONTH_NAMES, getMonthByDate, getYearByDate } from 'utils/date';
import {
	getTailSpendAnalysisConfigurationForProcessing,
	CUSTOM_CURRENCY_TYPE,
	getDuplicateArrayElements,
} from '../../Settings/utils';
import { DefaultValuesSection } from '../../Settings/DefaultValuesSection';
import { TailSpendSection } from '../TailSpendSection';
import { SpendCalculationSection } from '../SpendCalculationSection';
import { YearSettingsSection } from '../YearSettingsSection';
import { convertValueToUnitPair } from 'utils/number';
import InitiativeTimePeriod from './InitiativeTimePeriod';
import CategoryMultiSelect from './CategoryMultiSelect';
import { PERMISSIONS } from 'contexts/PermissionsContext';
import Modal from 'components/Modal';
import { ModalBody } from 'Benchmarks/components/BenchmarkContainer/EditRevenue/EditRevenue.styles';
import HistoryTable from './HistoryTable';

export const TAIL_SPEND_TYPES = {
	percentage: 0,
	value: 1,
	quantity: 2,
	vendorSpend: 3,
};

const defaultSettings = {
	tailSpend: 20,
	tailSpendType: 0,
	useNetSpend: false,
	financialYearStartMonth: null,
};

const DEFAULT_CATEGORY = [{ label: 'SELECT A FILTER', value: 0 }];
const getTitle = new Map([
	[8, ' By Child Companies'],
	[11, 'By Business Unit '],
	[31, 'By Country'],
]);
class FirstUsageSettings extends React.Component {
	static propTypes = {
		status: PropTypes.object.isRequired,
		value: PropTypes.object.isRequired,
	};

	state = {
		isLoading: true,
		tailSpendData: null,
		currenciesData: null,
		periodsData: null,
		inititivesPeriodsData: [],
		inititivesTotalPeriodsData: [],
		portfolioCompanies: {
			options: this.props.portfolioCompanies.options,
			isLoading: this.props.portfolioCompanies.isLoading,
		},
		category: {
			options: [],
			selected: [],
		},
		showPortcoHistoryModal: false,
		portcoHistory: [],
		tableRef: null,
	};

	componentDidMount() {
		this.fetchData();
	}

	fetchData = () => {
		const { onChange, status } = this.props;
		const isFirstTimeUsage = status.state === UPLOAD_STATUS.CLASSIFIED;

		Promise.all([
			getSettingsOptions(),
			getSpendCubeSettings(),
			getColumnWithData(),
		]).then(
			([
				options,
				{
					tailSpend,
					othersThreshold,
					spendCubeCurrency,
					initiativesDateRangeId,
					initiativesTotalSpendDateRangeId,
					spendCubeDateRangeId,
					vendorSpendAmount,
					tailSpendAnalysisConfiguration,
					legalEntity,
					companyId,
					isPortco,
					...restSpendCubeSettings
				},
				columnsData,
			]) => {
				this.setState({
					category: {
						options: columnsData.data,
						selected: [],
					},
				});
				const tailSpendValue =
					tailSpend.value != null ? tailSpend.value : defaultSettings.tailSpend;
				const tailSpendType =
					tailSpend.type === null
						? defaultSettings.tailSpendType
						: tailSpend.type;
				const useNetSpend =
					tailSpend.useNetSpend != null
						? tailSpend.useNetSpend
						: defaultSettings.useNetSpend;
				const financialYearStartMonth =
					restSpendCubeSettings.financialYearStartMonth ||
					defaultSettings.financialYearStartMonth;
				const customPeriods = options.dateRanges.filter(item => !item.year);
				const periodsData = options.dateRanges.filter(item => !!item.year);

				const customInititivesPeriods = options.dateRangesForInitiatives.filter(
					item => item.isCustom
				);
				const inititivesPeriodsData = options.dateRangesForInitiatives.filter(
					item => !item.isCustom
				);

				const customInititivesTotalPeriods = options.dateRangesForInitiativesTotalSpend.filter(
					item => item.isCustom
				);
				const inititivesTotalPeriodsData = options.dateRangesForInitiativesTotalSpend.filter(
					item => !item.isCustom
				);

				const customCurrency =
					options.currencies.find(item => item.isCustom) || {};
				const currenciesData = options.currencies.filter(
					item => !item.isCustom
				);
				const isCustomCurrencyActive =
					customCurrency.code === spendCubeCurrency;

				this.setState(
					{
						currenciesData,
						periodsData,
						inititivesPeriodsData,
						inititivesTotalPeriodsData,
					},
					() => {
						onChange(
							{
								legalEntity,
								companyId,
								isPortco,
								customCurrency,
								tailSpend: tailSpendValue,
								tailSpendType,
								useNetSpend,
								financialYearStartMonth,
								initiativePeriod: initiativesDateRangeId
									? initiativesDateRangeId.toString()
									: options.dateRangesForInitiatives &&
									  options.dateRangesForInitiatives[0] &&
									  options.dateRangesForInitiatives[0].id
										? options.dateRangesForInitiatives[0].id.toString()
										: null,

								initiativeTotalPeriod: initiativesTotalSpendDateRangeId
									? initiativesTotalSpendDateRangeId.toString()
									: options.dateRangesForInitiativesTotalSpend &&
									  options.dateRangesForInitiativesTotalSpend[0] &&
									  options.dateRangesForInitiativesTotalSpend[0].id
										? options.dateRangesForInitiativesTotalSpend[0].id.toString()
										: null,

								period: spendCubeDateRangeId
									? spendCubeDateRangeId.toString()
									: options.dateRanges &&
									  options.dateRanges[0] &&
									  options.dateRanges[0].id
										? options.dateRanges[0].id.toString()
										: null,
								customPeriods: this.getCustomPeriodsData(customPeriods),
								customInititivesPeriods: this.getCustomPeriodsData(
									customInititivesPeriods
								),
								customInititivesTotalPeriods: this.getCustomPeriodsData(
									customInititivesTotalPeriods
								),
								tailSpendAnalysisConfiguration:
									tailSpendAnalysisConfiguration &&
									getTailSpendAnalysisConfigurationForProcessing(
										tailSpendAnalysisConfiguration
									),
								currency: !isCustomCurrencyActive
									? spendCubeCurrency
										? spendCubeCurrency.toLowerCase()
										: options.currencies[0].code
									: CUSTOM_CURRENCY_TYPE,
								...(othersThreshold &&
									convertValueToUnitPair(othersThreshold, 'category')),
								...(vendorSpendAmount &&
									convertValueToUnitPair(vendorSpendAmount, 'vendorSpend')),
							},
							() => {
								this.setState({ isLoading: false }, () => {
									this.setValid(!isFirstTimeUsage);
									this.props.setLoading(false);
								});
							}
						);
					}
				);
			}
		);
	};

	componentDidUpdate(prevProps, prevState) {
		const { value, onStateChange } = this.props;
		const { isLoading } = this.state;
		const { value: oldValue } = prevProps;
		if (value.shouldRefresh && oldValue.shouldRefresh !== value.shouldRefresh) {
			this.fetchData();
			onStateChange(
				{ spendCubeSettings: { ...value, shouldRefresh: false } },
				true
			);
		}

		if (
			prevState.isLoading &&
			!isLoading &&
			this.props.location &&
			this.props.location.hash
		) {
			const hashElement = document.querySelector(this.props.location.hash);

			if (hashElement && hashElement.scrollIntoView) {
				hashElement.scrollIntoView();
			}
		}
	}

	getCustomPeriodsData = data => {
		return data.map(period => {
			const { dateFrom, dateTo, ...customPeriod } = period;

			return {
				...customPeriod,
				monthPickerRange: this.getMonthPickerRange(dateFrom, dateTo),
			};
		});
	};

	getInitialMonthpickerRange = () => {
		const { periodsData } = this.state;
		return {
			from: {
				year: periodsData[0].year,
				month: MONTH_NAMES[
					getMonthByDate(periodsData[0].dateFrom)
				].toLowerCase(),
				monthNumber: getMonthByDate(periodsData[0].dateFrom) + 1,
			},
			to: {
				year: periodsData[periodsData.length - 1].year,
				month: MONTH_NAMES[
					getMonthByDate(periodsData[periodsData.length - 1].dateTo)
				].toLowerCase(),
				monthNumber:
					getMonthByDate(periodsData[periodsData.length - 1].dateTo) + 1,
			},
		};
	};

	onPortfolioCompaniesChange = e => {
		const { onChange } = this.props;
		onChange({ legalEntity: e });
	};

	onCurrencyChange = e => {
		const { onChange } = this.props;

		onChange({ currency: e.target.value }, () => this.validateCustomCurrency());
	};

	handleVendorSpendValueChange = vendorSpendValue => {
		const { onChange } = this.props;

		onChange({ vendorSpendValue }, () => this.setValid());
	};

	handleCategoryValueChange = categoryValue => {
		const { onChange } = this.props;

		onChange({ categoryValue }, () => this.setValid());
	};

	onUnitChange = ({ target: { name, value } }) => {
		const { onChange } = this.props;

		onChange({
			[name]: UNITS.find(item => item.value === value).key,
		});
	};

	onPeriodChange = ({ target: { name, value } }) => {
		const { onChange } = this.props;

		onChange({ [name]: value });
	};

	setValid = skipStaleUpdate => {
		const {
			categoryValue,
			tailSpend,
			tailSpendType,
			customCurrency,
		} = this.props.value;

		const isTailSpendValid =
			tailSpendType !== TAIL_SPEND_TYPES.percentage ||
			isEmpty(validateTailSpend(tailSpend));

		const { onStateChange } = this.props;
		onStateChange(
			{
				isFormValid:
					this.isCustomPeriodsValid() &&
					!customCurrency.error &&
					isTailSpendValid &&
					categoryValue !== '',
			},
			skipStaleUpdate
		);
	};

	handleTailSpendChange = data => {
		const { onChange } = this.props;

		onChange(data, this.setValid);
	};

	handleMonthPickerBlockClick = (id, key) => {
		const { onChange, value } = this.props;
		const newPeriod = id.toString();

		if (value[key] !== newPeriod) {
			onChange({ [key]: newPeriod });
		}
	};

	handleMonthPickerChange = (customId, periodsKey, periodKey) => data => {
		const { onChange, value } = this.props;
		const periods = value[periodsKey];
		const newPeriod = customId.toString();

		// Deep clone array of objects
		const updatedCustomPeriods = JSON.parse(JSON.stringify(periods));
		const currentItem = updatedCustomPeriods.find(
			item => (item.id ? item.id === customId : item.uid === customId)
		);
		currentItem.monthPickerRange = data;

		onChange({
			[periodKey]: newPeriod,
			[periodsKey]: updatedCustomPeriods,
		});
	};

	onCustomInitiativePeriodNameChange = customId =>
		this.onCustomPeriodNameChange(
			customId,
			'customInititivesPeriods',
			this.validateInitiativeCustomPeriods
		);

	onCustomInitiativeTotalPeriodNameChange = customId =>
		this.onCustomPeriodNameChange(
			customId,
			'customInititivesTotalPeriods',
			this.validateInitiativeTotalCustomPeriods
		);

	onCustomAnalysisPeriodNameChange = customId =>
		this.onCustomPeriodNameChange(
			customId,
			'customPeriods',
			this.validateAnalysisCustomPeriods
		);

	onCustomPeriodNameChange = (customId, periodsKey, validateFunc) => e => {
		e.stopPropagation();
		const name = e.target.value;
		const { onChange, value } = this.props;
		const periods = value[periodsKey];
		// Deep clone array of objects
		const updatedCustomPeriods = JSON.parse(JSON.stringify(periods));
		const currentItem = updatedCustomPeriods.find(
			item => (item.id ? item.id === customId : item.uid === customId)
		);
		currentItem.name = name;

		onChange(
			{
				[periodsKey]: updatedCustomPeriods,
			},
			validateFunc
		);
	};

	validateAnalysisCustomPeriods = () => {
		const {
			value: { customPeriods },
		} = this.props;
		this.validateCustomPeriods(customPeriods, 'customPeriods');
	};

	validateInitiativeCustomPeriods = () => {
		const {
			value: { customInititivesPeriods },
		} = this.props;
		this.validateCustomPeriods(
			customInititivesPeriods,
			'customInititivesPeriods'
		);
	};

	validateInitiativeTotalCustomPeriods = () => {
		const {
			value: { customInititivesTotalPeriods },
		} = this.props;
		this.validateCustomPeriods(
			customInititivesTotalPeriods,
			'customInititivesTotalPeriods'
		);
	};

	validateCustomPeriods = debounce((periods, periodsKey) => {
		const { onChange } = this.props;
		const updatedCustomPeriods = JSON.parse(JSON.stringify(periods));
		const duplicateNames = getDuplicateArrayElements(
			updatedCustomPeriods.filter(item => item.name).map(item => item.name)
		);

		updatedCustomPeriods.forEach(item => {
			if (duplicateNames.includes(item.name)) {
				item.error = true;
			} else {
				item.error = false;
			}
		});

		onChange({ [periodsKey]: updatedCustomPeriods }, () => this.setValid());
	}, 200);

	isCustomPeriodsValid = () => {
		const { value } = this.props;
		const { customPeriods } = value;

		return !customPeriods.find(item => item.error);
	};

	addCustomAnalysisPeriod = () => {
		const {
			value: { customPeriods },
		} = this.props;
		this.addCustomPeriod(customPeriods, 'customPeriods');
	};

	addCustomInitiativesPeriod = () => {
		const {
			value: { customInititivesPeriods },
		} = this.props;
		this.addCustomPeriod(customInititivesPeriods, 'customInititivesPeriods');
	};

	addCustomInitiativesTotalPeriod = () => {
		const {
			value: { customInititivesTotalPeriods },
		} = this.props;
		this.addCustomPeriod(
			customInititivesTotalPeriods,
			'customInititivesTotalPeriods'
		);
	};

	addCustomPeriod = (periods, key) => {
		const { onChange } = this.props;

		onChange({
			[key]: [
				...periods,
				{
					uid: uniqueId('custom_'),
					monthPickerRange: this.getInitialMonthpickerRange(),
				},
			],
		});
	};

	removeAnalisysCustomPeriod = customId => {
		const {
			value: { customPeriods },
		} = this.props;
		this.removeCustomPeriod(
			customId,
			customPeriods,
			'customPeriods',
			this.validateAnalysisCustomPeriods
		);
	};

	removeInitiativesCustomPeriod = customId => {
		const {
			value: { customInititivesPeriods },
		} = this.props;
		this.removeCustomPeriod(
			customId,
			customInititivesPeriods,
			'customInititivesPeriods',
			this.validateInitiativeCustomPeriods
		);
	};

	removeInitiativesTotalCustomPeriod = customId => {
		const {
			value: { customInititivesTotalPeriods },
		} = this.props;
		this.removeCustomPeriod(
			customId,
			customInititivesTotalPeriods,
			'customInititivesTotalPeriods',
			this.validateInitiativeTotalCustomPeriods
		);
	};

	removeCustomPeriod = (customId, periods, key, validateFunc) => {
		const { onChange } = this.props;

		onChange(
			{
				[key]: periods.filter(
					period =>
						period.id ? period.id !== customId : period.uid !== customId
				),
			},
			validateFunc
		);
	};

	getPeriodString = () => {
		const { periodsData } = this.state;
		const { period, customPeriods } = this.props.value;
		const currentPeriod =
			[...periodsData, ...customPeriods].find(
				item => (item.id ? item.id.toString() === period : item.uid === period)
			) || {};

		if (!currentPeriod.monthPickerRange) {
			const { dateFrom, dateTo, year } =
				periodsData.find(item => item.id.toString() === period) || {};

			const months =
				getMonthByDate(dateTo) - getMonthByDate(dateFrom) === 11
					? 'Full Year'
					: `${MONTH_NAMES[getMonthByDate(dateFrom)]} - ${
							MONTH_NAMES[getMonthByDate(dateTo)]
					  }`;

			return `${year} (${months})`;
		} else {
			const { monthPickerRange } = currentPeriod;

			if (monthPickerRange.from.year === monthPickerRange.to.year) {
				const months =
					monthPickerRange.to.monthNumber -
						monthPickerRange.from.monthNumber ===
					11
						? 'Full Year'
						: `${MONTH_NAMES[monthPickerRange.from.monthNumber - 1]} - ${
								MONTH_NAMES[monthPickerRange.to.monthNumber - 1]
						  }`;
				return `${monthPickerRange.from.year} (${months})`;
			} else {
				return `${MONTH_NAMES[monthPickerRange.from.monthNumber - 1]} ${
					monthPickerRange.from.year
				} - ${MONTH_NAMES[monthPickerRange.to.monthNumber - 1]} ${
					monthPickerRange.to.year
				}`;
			}
		}
	};

	getMonthPickerRange = (dateFrom, dateTo) => {
		return {
			from: {
				year: getYearByDate(dateFrom),
				month: MONTH_NAMES[getMonthByDate(dateFrom)].toLowerCase(),
				monthNumber: getMonthByDate(dateFrom) + 1,
			},
			to: {
				year: getYearByDate(dateTo),
				month: MONTH_NAMES[getMonthByDate(dateTo)].toLowerCase(),
				monthNumber: getMonthByDate(dateTo) + 1,
			},
		};
	};

	getMonthPickerSrcRange = () => {
		const data = this.state.periodsData;

		return {
			from: {
				year: data[0].year,
				month: getMonthByDate(data[0].dateFrom) + 1,
			},
			to: {
				year: data[data.length - 1].year,
				month: getMonthByDate(data[data.length - 1].dateTo) + 1,
			},
		};
	};
	onCategoryChange = e => {
		this.setState({
			category: { ...this.state.category, selected: e },
		});
		this.props.onChange({ companyId: e.value });
	};
	onCustomCurrencyInputChange = (value, e) => {
		e.stopPropagation();
		const { onChange, value: spendCubeSettings } = this.props;
		const { name } = e.target;
		// Remove special characters from currency code
		const formattedValue =
			name === 'code' ? value.toLowerCase().replace(/[\W_]+/g, '') : value;

		onChange(
			{
				customCurrency: {
					...spendCubeSettings.customCurrency,
					[name]: formattedValue,
				},
			},
			() => this.validateCustomCurrency()
		);
	};

	validateCustomCurrency = debounce(() => {
		const { onChange, value } = this.props;
		const { currenciesData } = this.state;
		const { currency, customCurrency } = value;
		const currencyList = currenciesData.map(item => item.code);
		let error;

		if (currency === CUSTOM_CURRENCY_TYPE && !customCurrency.code) {
			error = 'Active currency should not be empty';
		}

		if (currencyList.includes(customCurrency.code)) {
			error = 'Duplicate currency code';
		}

		onChange({ customCurrency: { ...customCurrency, error } }, () =>
			this.setValid()
		);
	}, 200);

	getUnsavedCustomPeriodDateRange() {
		const { value } = this.props;
		const { period, customPeriods } = value;

		const unsavedCustomPeriod = customPeriods.find(
			customPeriod => customPeriod.uid === period
		);

		return unsavedCustomPeriod
			? {
					dateFrom: getISOString(
						unsavedCustomPeriod.monthPickerRange.from.year,
						unsavedCustomPeriod.monthPickerRange.from.monthNumber
					),
					dateTo: getISOString(
						unsavedCustomPeriod.monthPickerRange.to.year,
						unsavedCustomPeriod.monthPickerRange.to.monthNumber,
						true
					),
			  }
			: undefined;
	}
	getSelectedCategory = () => {
		const { category } = this.state;
		const { value } = this.props;
		return (
			this.state.category.options.find(
				item => item.value === category.selected.value
			) ||
			this.state.category.options.find(item => item.value === value.companyId)
		);
	};
	handlePortcoHistoryModal = () => {
		getPortcoTraces()
			.then(response => {
				this.setState({
					portcoHistory: response.data,
				});
			})
			.then(() => {
				this.setState({
					showPortcoHistoryModal: true,
				});
			});
	};
	handleTableRef = ref => {
		this.setState({
			tableRef: ref,
		});
	};
	render() {
		const {
			status,
			value,
			saveButtonDisabled,
			onApplySettings,
			portfolioCompanies,
			isParent,
			permissions,
		} = this.props;
		const {
			currency,
			period,
			initiativePeriod,
			initiativeTotalPeriod,
			categoryValue,
			categoryUnit,
			vendorSpendUnit,
			vendorSpendValue,
			customPeriods,
			customInititivesPeriods,
			customInititivesTotalPeriods,
			customCurrency,
			useNetSpend,
			financialYearStartMonth,
			legalEntity,
			companyId,
			isPortco,
		} = value;
		const {
			isLoading,
			currenciesData,
			periodsData,
			inititivesPeriodsData,
			inititivesTotalPeriodsData,
			category,
			showPortcoHistoryModal,
			portcoHistory,
		} = this.state;

		if (isLoading) {
			return <LoadingIndicator loading />;
		}

		const unsavedCustomPeriodDateRange = this.getUnsavedCustomPeriodDateRange();
		const legalEntityList = legalEntity === null ? [] : legalEntity;

		return (
			<React.Fragment>
				{!status.isDataPublished && (
					<SectionWrapper>
						<IntroText>
							<ApIcon iconName="outline_error" iconColor={chartOrange} />
							<span>
								You need to configure Spend X-Ray before it can be used
							</span>
						</IntroText>
					</SectionWrapper>
				)}
				{permissions.includes(PERMISSIONS.PortcoVisible) && (
					<Section
						title={`Environment Settings`}
						animationIndex={0}
						tooltipVisible={true}
						toolTipContent={
							<TooltipContent>
								Enabling the 'Portco CheckBox' will modify the Environment Type
								to Portco. The current user will automatically become a parent
								by default. To grant access to other users, the current user
								will need to add them.<br />
								<br />
								Disabling the 'Portco CheckBox' will switch the Environment Type
								to Portco, granting all users access. The Access Control will be
								hidden in this scenario.
							</TooltipContent>
						}
						onClickFunc={this.handlePortcoHistoryModal}
						iconName="history"
					>
						<SectionFormLabel>Switch to Portco</SectionFormLabel>
						<ApCheckbox
							id="isPortco"
							name="Is Portco Flag"
							checked={isPortco}
							onChange={e =>
								this.props.onChange({ isPortco: e.target.checked })
							}
						/>
					</Section>
				)}
				{showPortcoHistoryModal && (
					<>
						<Modal
							width="1000px"
							zIndex="10000000"
							title="Enivornment Access History"
							submitLabel="Ok"
							// cancelLabel="Export"
							// onClose={() => tableRef()}
							onSubmit={() =>
								this.setState({
									showPortcoHistoryModal: false,
								})
							}
						>
							<ModalBody>
								<HistoryTable
									data={portcoHistory}
									handleTableRef={this.handleTableRef}
								/>
							</ModalBody>
						</Modal>
					</>
				)}
				{isParent && (
					<Section
						title={`Portfolio Filter  ${getTitle.get(companyId) || ''}`}
						animationIndex={0}
					>
						<SectionFormLabel>Select child column</SectionFormLabel>
						<ApSimpleDropdown
							options={category.options}
							selected={this.getSelectedCategory() || category.options}
							onChange={this.onCategoryChange}
						/>
						{category.selected.value === undefined && (
							<>
								<SectionFormLabel>Select child values</SectionFormLabel>
								<MultiSelectWrapper>
									<CategoryMultiSelect
										name="portfoliocompanies"
										label={`Select  ${getTitle.get(companyId) || ''}`}
										options={portfolioCompanies.options || DEFAULT_CATEGORY}
										selected={legalEntityList}
										disabled={portfolioCompanies.isLoading}
										isLoading={portfolioCompanies.isLoading}
										onChange={this.onPortfolioCompaniesChange}
									/>
								</MultiSelectWrapper>
							</>
						)}
					</Section>
				)}

				<Section title="Default Currency" animationIndex={0}>
					<RadioGroup
						name="currency"
						value={currency}
						onChange={this.onCurrencyChange}
					>
						{currenciesData.map(({ code }) => (
							<Radio style={slimRadioStyles} key={code} value={code}>
								{code.toUpperCase()}
							</Radio>
						))}
						<CurrencyRadio
							value={CUSTOM_CURRENCY_TYPE}
							style={slimRadioStyles}
							isError={!!customCurrency.error}
						>
							<CurrencyInputWrapper>
								<ApInput
									name="code"
									label="Currency code"
									errorMessage={customCurrency.error}
									maxLength={3}
									value={
										customCurrency.code ? customCurrency.code.toUpperCase() : ''
									}
									onChange={this.onCustomCurrencyInputChange}
								/>
							</CurrencyInputWrapper>
							<CurrencyInputWrapper>
								<ApInput
									name="symbol"
									label="Currency symbol"
									maxLength={3}
									value={customCurrency.symbol || ''}
									onChange={this.onCustomCurrencyInputChange}
								/>
							</CurrencyInputWrapper>
						</CurrencyRadio>
					</RadioGroup>
				</Section>
				<DefaultValuesSection
					animationIndex={3}
					hideDecimals={this.props.hideDecimals}
					onChange={this.props.onStateChange}
				/>
				<Section title="Analysis default Time Period" animationIndex={1}>
					<PeriodWrapper>
						<RadioGroup
							name="period"
							value={period}
							onChange={this.onPeriodChange}
						>
							{periodsData.map((item, index) => (
								<Radio
									key={index}
									value={item.id.toString()}
									style={slimRadioStyles}
								>
									{item.year}
									<PeriodRange>
										{getMonthByDate(item.dateTo) -
											getMonthByDate(item.dateFrom) ===
										11
											? 'Full Year'
											: `${MONTH_NAMES[getMonthByDate(item.dateFrom)]} - ${
													MONTH_NAMES[getMonthByDate(item.dateTo)]
											  }`}
									</PeriodRange>
								</Radio>
							))}
							{customPeriods.map(
								({ id, uid, monthPickerRange, name, error }, index) => (
									<MonthPickerRadio
										style={{
											...slimRadioStyles,
											marginTop: index === 0 ? 10 : 0,
										}}
										value={id ? id.toString() : uid}
										key={id || uid}
									>
										<MonthPickerWrapper
											isActive={id ? id.toString() === period : uid === period}
										>
											<MonthPicker
												onClick={() => {
													this.handleMonthPickerBlockClick(id || uid, 'period');
												}}
												srcRange={this.getMonthPickerSrcRange()}
												onConfirm={this.handleMonthPickerChange(
													id || uid,
													'customPeriods',
													'period'
												)}
												stateRange={monthPickerRange}
												index={index}
											/>

											<MonthPickerNameBlock>
												<SmallInput error={error}>
													<TextInput
														name="customPeriodName"
														label={index === 0 ? 'Custom Period Name' : ''}
														value={name || ''}
														onChange={this.onCustomAnalysisPeriodNameChange(
															id || uid
														)}
													/>
												</SmallInput>
											</MonthPickerNameBlock>

											<ActionWrapper>
												{(id ? id.toString() !== period : uid !== period) && (
													<ApIcon
														iconName="baseline_close"
														iconSize="24px"
														onClick={() =>
															this.removeAnalisysCustomPeriod(id || uid)
														}
													/>
												)}
											</ActionWrapper>
										</MonthPickerWrapper>
									</MonthPickerRadio>
								)
							)}
						</RadioGroup>
						<LinkButton onClick={this.addCustomAnalysisPeriod}>
							Add{customPeriods.length !== 0 ? ' new' : ''} custom period
						</LinkButton>
					</PeriodWrapper>
				</Section>

				<div id="initiatives_time_period" />
				<InitiativeTimePeriod
					addCustomPeriod={this.addCustomInitiativesPeriod}
					removeCustomPeriod={this.removeInitiativesCustomPeriod}
					period={initiativePeriod}
					periodsData={inititivesPeriodsData}
					customPeriods={customInititivesPeriods}
					onChange={this.onChange}
					onPeriodChange={this.onPeriodChange}
					handleMonthPickerBlockClick={this.handleMonthPickerBlockClick}
					getMonthPickerSrcRange={this.getMonthPickerSrcRange}
					handleMonthPickerChange={this.handleMonthPickerChange}
					onCustomPeriodNameChange={this.onCustomInitiativePeriodNameChange}
					addCustomTotalPeriod={this.addCustomInitiativesTotalPeriod}
					removeCustomTotalPeriod={this.removeInitiativesTotalCustomPeriod}
					totalPeriod={initiativeTotalPeriod}
					periodsTotalData={inititivesTotalPeriodsData}
					customTotalPeriods={customInititivesTotalPeriods}
					onCustomInitiativeTotalPeriodNameChange={
						this.onCustomInitiativeTotalPeriodNameChange
					}
				/>

				<div id="financial_year" />
				<YearSettingsSection
					animationIndex={5}
					financialYearStartMonth={financialYearStartMonth}
					onChange={this.props.onChange}
				/>

				<SpendCalculationSection
					animationIndex={5}
					useNetSpend={useNetSpend}
					onChange={this.props.onChange}
				/>

				<div id="tail_spend" />
				<TailSpendSection
					onChange={this.handleTailSpendChange}
					value={value}
					animationIndex={6}
					currency={currency}
					periodsData={periodsData}
					onApplySettings={onApplySettings}
					saveButtonDisabled={saveButtonDisabled}
					dateRangeId={+period || undefined}
					previewDateRange={unsavedCustomPeriodDateRange}
				/>

				<Section
					title={'"Other" category grouping threshold'}
					description={
						<p>
							For all spend and head spend, categories under a certain spend
							threshold can be grouped together into an "Other" category <br />on
							the chart.
						</p>
					}
					animationIndex={7}
					layout="columns"
				>
					<SectionForm>
						<SectionFormLabel>Category head spend threshold</SectionFormLabel>

						<ValueWrapper>
							<ApInput
								type="number"
								name="categoryValue"
								onChange={this.handleCategoryValueChange}
								value={categoryValue}
								shouldStopPropagation
							/>
						</ValueWrapper>
						<SelectWrapper>
							<Select
								name="categoryUnit"
								label=""
								options={UNITS}
								value={UNITS.find(item => item.key === categoryUnit).value}
								onChange={this.onUnitChange}
							/>
						</SelectWrapper>
					</SectionForm>
				</Section>

				<Section
					title="High value threshold"
					description={
						<React.Fragment>
							<p>
								For all spend and head spend, the number of vendors with spend
								above a certain threshold is displayed in the "Top L4 category"
								table.
							</p>
							<p> Set the high spend threshold values here.</p>
						</React.Fragment>
					}
					animationIndex={8}
					layout="columns"
				>
					<SectionForm>
						<SectionFormLabel>Count vendors with spend over</SectionFormLabel>

						<ValueWrapper>
							<ApInput
								type="number"
								name="vendorSpendValue"
								onChange={this.handleVendorSpendValueChange}
								value={vendorSpendValue}
								shouldStopPropagation
							/>
						</ValueWrapper>
						<SelectWrapper>
							<Select
								name="vendorSpendUnit"
								label=""
								options={UNITS}
								value={UNITS.find(item => item.key === vendorSpendUnit).value}
								onChange={this.onUnitChange}
							/>
						</SelectWrapper>
					</SectionForm>
				</Section>
			</React.Fragment>
		);
	}
}

export default FirstUsageSettings;
